import React from 'react';
import PropTypes from 'prop-types';
import { animateScroll as scroll } from 'react-scroll';

import _debounce from 'lodash/debounce';
import _throttle from 'lodash/throttle';

import supportsPassiveEvents from '../utils/supports-passive-events';

import Title from '../components/title';
import withDevice from '../components/withDevice';

class InternalMenu extends React.Component {
    static propTypes = {
        device: PropTypes.object.isRequired,
        items: PropTypes.arrayOf(
            PropTypes.shape({
                text: PropTypes.string.isRequired,
            }),
        ),
        active: PropTypes.bool,
    };

    constructor(props) {
        super(props);
        this._debouncedUpdateItems = _debounce(this.updateItems, 100);
        this._throttledSetActive = _throttle(this.setActive, 100);

        this.state = {
            items: [],
            active: 0,
            clicked: null,
        };
    }

    componentDidMount() {
        this.updateItems();
        window.addEventListener('resize', this._debouncedUpdateItems);
        window.addEventListener(
            'scroll',
            this._throttledSetActive,
            supportsPassiveEvents() ? { passive: true } : false,
        );
        window.addEventListener('internal-menu-items-loaded', this.updateItems);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this._debouncedUpdateItems);
        window.removeEventListener('scroll', this._throttledSetActive);
    }

    updateItems = () => {
        const content = document.getElementById('page-content');
        const headings = content.querySelectorAll('h1, h2');

        let items = [];
        headings.forEach((heading) => {
            const text = heading.innerHTML;
            const top = heading.offsetTop;
            items.push({ text, top, active: false });
        });

        this.setState({ items }, this.setActive);
    };

    setActive = () => {
        const { items, clicked, active, scrollToVal } = this.state;

        // Add slight buffer (25) so nav item stays active when clicked
        const scrollTop = window.scrollY + 25;
        const pageBottom =
            window.innerHeight + window.scrollY >= document.body.offsetHeight;
        const numItems = Object.entries(items).length;

        for (let [i, item] of Object.entries(items)) {
            const next = +i + 1 > numItems - 1 ? numItems - 1 : +i + 1;

            if (scrollTop <= items[next]?.top) {
                this.setState({ active: +i });
                break;
            } else if (+i >= next && scrollTop > items[next]?.top) {
                this.setState({ active: +i });
                break;
            }
        }

        if (pageBottom || scrollToVal === scrollTop) {
            if (pageBottom && clicked > active) {
                this.setState({
                    active: clicked,
                    clicked: null,
                });
            }
        }
    };

    render() {
        const { items, active } = this.state;
        return this.props.device.isDesktop ? (
            <ul className="page__menu page__menu--internal">
                {items.map((item, i) => (
                    <Title
                        key={i}
                        level={6}
                        tag="li"
                        className={`
                            page__menu__item
                            page__menu__item--internal
                            ${active === i ? '-active' : ''}
                        `}>
                        <a
                            href="#"
                            title={item.text}
                            dangerouslySetInnerHTML={{ __html: item.text }}
                            onClick={(e) => {
                                e.preventDefault();

                                this.setState({
                                    active: i,
                                    clicked: i,
                                    scrollToVal: item.top,
                                });
                                scroll.scrollTo(item.top);
                            }}
                        />
                    </Title>
                ))}
            </ul>
        ) : null;
    }
}

export default withDevice(InternalMenu);

export const itemsLoaded = () => {
    const event = new Event('internal-menu-items-loaded');
    window.dispatchEvent(event);
};
